import script from "./ChoppinessIndex.vue?vue&type=script&lang=js"
export * from "./ChoppinessIndex.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__